<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 2; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div
        class="
          asc-page-heading-2
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="d-flex align-items-center">
          <img
            @click="gobackpointer"
            class="mr-3 pointer"
            src="../../assets/customfield/blueBackArrow.svg"
            alt=""
          />
          Bookmarked Candidates
        </div>
      </div>
      <div class="search-candidate-right-container-wide">
        <!-- <div
            v-if="allSearchCandidatesData.length == 0"
            class="d-flex justify-content-center align-items-center h-100"
          >
            <img
              src="../../assets/img/cvsearch/noCVSearch.svg"
              alt=""
              srcset=""
            />
          </div> -->
        <template>
          <div
            v-if="profiles.length"
            class="
              d-flex
              align-items-center
              justify-content-between
              cv-right-header
            "
          >
            <div>
              <div class="cv-black-txt">
                {{ total }} Profile(s) have been bookmarked.
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div class="bluebtn position-relative">
                <b-button
                  ref="addDropdownBtn"
                  class="acs-addBtn mr-3"
                  @click="showAddDropdown = !showAddDropdown"
                  :disabled="selectCand.length == 0"
                >
                  <img
                    src="../../assets/img/accessconnew/whitePlus.svg"
                    alt
                    class="mr-2"
                  />
                  <span class>Add</span>
                  <img
                    class="ml-2"
                    src="../../assets/whitedownarr.svg"
                    alt=""
                  />
                </b-button>
                <div
                  ref="addDropdown"
                  class="cv-add-dropdown pointer"
                  v-if="showAddDropdown"
                  v-closable="{
                    exclude: ['addDropdown', 'addDropdownBtn'],
                    handler: 'hideAddDropdown',
                  }"
                >
                  <div
                    class="d-flex align-items-center landpage-unsel"
                    @click="showJobModal"
                  >
                    <img
                      src="../../assets/cvsearch/addtojob.svg"
                      alt
                      class="mr-2"
                    />
                    Add to Job
                  </div>
                  <div
                    class="d-flex align-items-center landpage-unsel"
                    @click="goToAddToTalentPool"
                  >
                    <img
                      src="../../assets/cvsearch/addtoTP.svg"
                      alt
                      class="mr-2"
                    />
                    Add to Talent Pool
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="profiles.length == 0 && !loaderStatus"
            class="
              d-flex
              flex-column
              align-items-center
              justify-content-center
              w-100
              h-100
            "
          >
            <img src="../../assets/cvsearch/noBookmarkedProfiles.svg" alt="" />
            <span class="text-center cv-grey-txt">
              {{
                searchQuery
                  ? `No matching results for "${searchQuery}"`
                  : "There are no bookmarked profiles"
              }}
            </span>
          </div>
          <div v-else class="p-2 cv-right-overflow-2">
            <b-row>
              <b-col
                v-for="(profile, i) in profiles"
                :key="i"
                cols="6"
                :class="i % 2 == 1 ? 'pl-0' : 'pr-1'"
              >
                <div class="cv-new-card m-1">
                  <div class="border-bottom cv-top-card">
                    <div class="d-flex justify-content-between w-100">
                      <div class="d-flex align-items-center">
                        <div class="common-single-checkbox mr-1">
                          <b-form-checkbox
                            :value="profile.userID"
                            v-model="selectCand"
                          ></b-form-checkbox>
                        </div>
                        <div class="cv-profile-img">
                          <img
                            class="h-100 w-100"
                            :src="profile.image"
                            alt="Profile Image"
                          />
                        </div>
                        <div class="ml-2">
                          <div class="cv-name-txt">
                            {{ profile.firstName }} {{ profile.middleName }}
                            {{ profile.lastName }}
                          </div>
                          <div class="cv-desig-txt mt-1">
                            {{ profile.designation }}
                          </div>
                        </div>
                      </div>

                      <div class="d-flex flex-column align-items-end">
                        <div class="d-flex">
                          <div
                            class="
                              d-flex
                              cv-icon-container
                              mr-2
                              position-relative
                              pointer
                            "
                            tabindex="0"
                            @focusout="hideCopyToClipboardOnFocusOut"
                          >
                            <img
                              src="../../assets/cvsearch/call.svg"
                              alt=""
                              @click="toggleContactDropdown(profile.userID)"
                              v-b-tooltip.hover.top="'Contact'"
                            />
                            <div
                              v-if="currentContactDropdown === profile.userID"
                              class="cv-tooltip"
                            >
                              <div
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                "
                              >
                                <div class="mr-4">
                                  {{ profile.phoneNumber }}
                                </div>
                                <div>
                                  <img
                                    v-if="isCopied === 'phone'"
                                    class="pointer"
                                    src="../../assets/cvsearch/tick.svg"
                                    alt=""
                                  />
                                  <img
                                    v-else
                                    class="pointer"
                                    src="../../assets/cvsearch/copy.svg"
                                    alt=""
                                    @click="
                                      (isCopied = 'phone'),
                                        copyToClipboard(profile.phoneNumber)
                                    "
                                  />
                                </div>
                              </div>
                              <div
                                class="
                                  mt-2
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                "
                              >
                                <div class="mr-4">
                                  {{ profile.email }}
                                </div>
                                <div>
                                  <img
                                    v-if="isCopied === 'email'"
                                    class="pointer"
                                    src="../../assets/cvsearch/tick.svg"
                                    alt=""
                                  />
                                  <img
                                    v-else
                                    class="pointer"
                                    src="../../assets/cvsearch/copy.svg"
                                    alt=""
                                    @click="
                                      (isCopied = 'email'),
                                        copyToClipboard(profile.email)
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="d-flex cv-icon-container mr-2 pointer"
                            @click="viewProfile(profile)"
                          >
                            <img
                              src="../../assets/cvsearch/view.svg"
                              alt=""
                              v-b-tooltip.hover.top="'View'"
                            />
                          </div>
                          <div
                            class="d-flex cv-icon-container pointer"
                            @click="toggleBookmarkAndFetch(profile)"
                          >
                            <img
                              v-if="profile.bookmark === true"
                              src="../../assets/cvsearch/filledBookmark.svg"
                              alt=""
                              v-b-tooltip.hover.top="'Remove Bookmark'"
                            />
                            <img
                              v-else
                              src="../../assets/cvsearch/Bookmark.svg"
                              alt=""
                              v-b-tooltip.hover.top="'Bookmark'"
                            />
                          </div>
                        </div>

                        <div class="cv-view-tag mt-2" v-if="profile.viewed">
                          Viewed
                        </div>
                      </div>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        w-100
                        mt-3
                      "
                    >
                      <div class="d-flex align-items-center">
                        <img
                          class="mr-2"
                          src="../../assets/cvsearch/experience.svg"
                          alt=""
                        /><span class="cv-desig-txt">{{
                          formatExperience(profile.totalYearsOfExp)
                        }}</span>
                      </div>
                      <div class="d-flex align-items-center">
                        <img
                          class="mr-2"
                          src="../../assets/cvsearch/package.svg"
                          alt=""
                        />
                        <div>
                          <div class="cv-desig-txt">
                            {{
                              profile.expectedCTC
                                ? `${profile.expectedCTC} LPA`
                                : "NA"
                            }}
                          </div>
                          <div class="cv-light-txt">(Expected)</div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <img
                          class="mr-2"
                          src="../../assets/cvsearch/location.svg"
                          alt=""
                        />
                        <div>
                          <div class="cv-desig-txt">
                            {{ profile.willingToRelocateTo[0] || "NA" }}
                          </div>
                          <div class="cv-light-txt">(Preferred)</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="">
                    <div
                      class="
                        mt-1
                        mb-2
                        d-flex
                        justify-content-between
                        align-items-center
                        pl-4
                        pr-4
                        w-100
                      "
                    >
                      <div
                        class="d-flex align-items-center w-25 cv-desig-txt-2"
                      >
                        <img
                          class="mr-2"
                          src="../../assets/cvsearch/education.svg"
                          alt=""
                        />Education
                      </div>
                      <div
                        class="
                          w-75
                          text-truncate
                          cv-desig-txt
                          d-flex
                          justify-content-start
                        "
                      >
                        <span
                          v-b-tooltip.hover.top="
                            formatEducation(profile.educationalInfo[0])
                          "
                          class="text-truncate d-inline-block tooltip-width-fix"
                          >{{
                            formatEducation(profile.educationalInfo[0])
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="
                        mt-1
                        mb-2
                        d-flex
                        justify-content-between
                        align-items-center
                        pl-4
                        pr-4
                        w-100
                      "
                    >
                      <div
                        class="d-flex align-items-center w-25 cv-desig-txt-2"
                      >
                        <img
                          class="mr-2"
                          src="../../assets/cvsearch/skills.svg"
                          alt=""
                        />Skills
                      </div>
                      <div
                        class="
                          w-75
                          text-truncate
                          cv-desig-txt
                          d-flex
                          justify-content-start
                        "
                      >
                        <span
                          v-b-tooltip.hover.top="profile.skillsArray.join(', ')"
                          class="text-truncate d-inline-block tooltip-width-fix"
                          >{{
                            profile.skillsArray.length == 0
                              ? "NA"
                              : profile.skillsArray.join(", ")
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- pagination -->
          <div
            v-if="profiles.length"
            class="
              acs-paginaTion-new
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div class="d-flex">
              <span class="acs-gotopage-text mr-2 p-1">Go to page</span>
              <b-form-input
                type="text"
                class="acs-pagination-num"
                v-model="goToPage"
                @keyup.enter="
                  goToPage == null || goToPage == '' || !iscontainsNumber
                    ? ''
                    : goToPages()
                "
                @keypress="NumbersOnly"
                @paste="handlePaste"
              >
              </b-form-input>
              <div class="acs-pagination-addbtn">
                <span
                  :class="
                    goToPage == null || goToPage == '' || !iscontainsNumber
                      ? 'disableDeleteIcon pl-3 mt-1'
                      : 'pointer pl-3 mt-1'
                  "
                >
                  <img
                    @click="
                      goToPage == null || goToPage == '' || !iscontainsNumber
                        ? ''
                        : goToPages()
                    "
                    src="../../assets/panelist/page_arrow.svg"
                    alt
                  />
                </span>
              </div>
            </div>
            <div
              style="width: 50%"
              class="d-flex justify-content-center pagination"
            >
              <b-pagination
                :total-rows="total"
                :per-page="pageCount"
                v-model="currentPage"
                @input="getBookmarkedCandidates"
                align="center"
                first-number
                last-number
              >
                <template #prev-text
                  ><span
                    ><img
                      src="../../assets/img/accessconnew/pageleft.svg"
                      alt=""
                    /> </span
                ></template>
                <template #next-text
                  ><span
                    ><img
                      src="../../assets/img/accessconnew/pageright.svg"
                      alt="" /></span
                ></template>
              </b-pagination>
            </div>
            <div class="d-flex align-items-center">
              <PageInput
                :pagecount="pageCount"
                @update-value="updatePageCount"
              />
              <div
                class="
                  acs-gotopage-text
                  mr-2
                  ml-4
                  d-flex
                  align-items-center
                  justify-content-end
                "
              >
                Results : <span class="ml-1" v-if="pageStart > total">0</span
                ><span v-else class="ml-1">{{ pageStart }}</span>
                <span class="ml-1"> - {{ pageEnd }} </span>
                <span class="pl-1"></span> of <span class="pr-1"></span
                >{{ total }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <AddtoJDModal
      v-if="showAddToJd"
      :showModal="showAddToJd"
      :candidateSelectedToThirdParty="populatedCustomFields"
      @close-modal="(showAddToJd = false), closeAddToJDSuccessMultiple()"
      :isSingle="false"
      :from="'cvSearch'"
    />
    <AddToJDSuceessMultiple
      v-if="showCandTPModal"
      :showCandTPModal="showCandTPModal"
      :from="'cvSearch'"
      :selectedjd="selectedjd"
      :candidateSelectedToThirdParty="populatedCustomFields"
      @hide-cand-tp-modal="
        (showCandTPModal = false), closeAddToJDSuccessMultiple()
      "
      @candidates-failed="closeAddToJDSuccessMultiple"
    />
  </div>
</template>

<script>
import { getBookmarkedProfiles } from "../../utils/apiFunctions";
import { mapGetters } from "vuex";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import cvSearch from "../../components/mixin/cvSearch";
import toast from "../../components/mixin/toast";
import PageInput from "../../components/InputComponents/PaginationInput.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import AddtoJDModal from "../../controllers/Talentpool/AddtoJDModal.vue";
import AddToJDSuceessMultiple from "../../controllers/Talentpool/AddToJDSuceessMultiple.vue";
import commonFunc from "../../components/mixin/commonFunctions.js";

export default {
  name: "BookmarkedCandidates.vue",
  mixins: [cvSearch, toast, commonFunc],
  components: {
    Spinner,
    AddtoJDModal,
    AddToJDSuceessMultiple,
    PageInput,
  },
  data() {
    return {
      // STRINGS
      isCopied: "",

      // ARRAYS
      selectedProfiles: [],
      selectCand: [],
      timePeriods: ["15 days", "1 Month", "2 Months", "3 Months", "Any"],
      profiles: [],
      allSearchCandidatesData: [],
      selectedjd: [],

      // BOOLEAN
      showCandTPModal: false,
      showAddToJd: false,
      showAddDropdown: false,
      loaderStatus: false,
      isViewing: false,
      roundModal: true,
      showSearchNameExistError: false,
      bookmarkTitle: false,

      // NUMBERS
      page: 0,
      goToPage: null,
      currentContactDropdown: null,
      totalPages: null,
      currentKeyword: null,
      pageCount: 50,
      pageStart: null,
      pageEnd: null,
      pageNumberToGo: null,
      total: null,
      currentPage: 1,
      cardsno: 25,
    };
  },
  created() {
    this.getBookmarkedCandidates();
  },
  methods: {
    updatePageCount(pageCount) {
      this.pageCount = pageCount;
      this.currentPage = 1;
      this.getBookmarkedCandidates();
    },
    hideAddDropdown() {
      this.showAddDropdown = false;
    },
    viewProfile(profile) {
      this.$router.push({
        name: "ViewCandidateProfile",
        params: {
          email: profile.email,
          componentName: "Bookmarked",
        },
      });
    },
    async toggleBookmarkAndFetch(profile) {
      this.loaderStatus = true;
      await this.bookmark(profile);
      this.getBookmarkedCandidates();
    },
    gobackpointer() {
      this.$router.go(-1);
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    async getBookmarkedCandidates() {
      this.loaderStatus = true;
      try {
        const res = await getBookmarkedProfiles({
          page: this.currentPage - 1,
          count: this.pageCount,
          searchQuery: this.searchQuery,
        });

        if (res.status == 200) {
          this.profiles = res.data.data.data;
          this.total = res.data.data.total;
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.currentPage = Math.floor(this.pageStart / this.pageCount) + 1;
          this.totalPages = Math.ceil(this.total / this.pageCount);
        } else {
          this.errorToast("Failed to fetch profiles");
        }
      } catch (err) {
        this.errorToast("Failed to fetch profiles");
      }
      this.loaderStatus = false;
    },
  },
  computed: {
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("cvSearchVUEX", {
      getJobIDs: "getJobIDs",
      whereFrom: "whereFrom",
    }),
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.getBookmarkedCandidates();
        }
      }
    },
  },
};
</script>
